import React from 'react';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { shorthand } from '../utils/css-utils';
import { GenericImageWithSplitResolutionsForOutlook } from './generic-image';
export class SectionImage extends React.Component {
    render() {
        const { section, cssClass, columnCssClass } = this.props;
        const imageProps = section.link ? { href: section.link } : {};
        const { innerPadding, outerPadding, containerBackground, containerBorder } = section;
        return (React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
                React.createElement(Column, { padding: shorthand(innerPadding), cssClass: columnCssClass, backgroundColor: containerBackground || undefined, border: containerBorder },
                    React.createElement(GenericImageWithSplitResolutionsForOutlook, { src: section.srcRetina, srcNonRetina: section.src, width: section.width, probableWidth: section.probableWidth, probableHeight: section.probableHeight, ...imageProps, alt: section.altText, imgStyle: section.imgStyle, showAfterLoad: true, renderWithText: true })))));
    }
}
//# sourceMappingURL=section-image.js.map